import { appendTestableComponentAttributes, TestableComponentProps } from '@dreryk/react-components';

import { StyledDisplayableLink } from './DisplayableLink.styled';

export type DisplayableLink = {
   href: string;
   label: string;
};

type DispayableLinkProps = TestableComponentProps & DisplayableLink;

export const DisplayableLink = (props: DispayableLinkProps): JSX.Element => {
   return (
      <StyledDisplayableLink
         {...appendTestableComponentAttributes('DispayableLink', props.testId)}
         href={props.href}
         target={'_blank'}
      >
         {props.label}
      </StyledDisplayableLink>
   );
};
